// Just enough markdown for model answers: **bold**, *italic*, "- " / "• "
// bullets, "### " headings and paragraphs. Escapes HTML first, so the result is
// safe for v-html.
export function renderAnswer(text) {
  const esc = String(text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
  const inline = (s) =>
    s
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/(^|[^*])\*([^*\s][^*]*?)\*(?!\*)/g, "$1<em>$2</em>");
  const out = [];
  let list = null;
  for (const raw of esc.split("\n")) {
    const line = raw.trim();
    const bullet = line.match(/^(?:[-•*]|\d+\.)\s+(.*)/);
    if (bullet) {
      if (!list) list = [];
      list.push(`<li>${inline(bullet[1])}</li>`);
      continue;
    }
    if (list) {
      out.push(`<ul>${list.join("")}</ul>`);
      list = null;
    }
    if (!line) continue;
    const heading = line.match(/^#{1,4}\s+(.*)/);
    out.push(heading ? `<h4>${inline(heading[1])}</h4>` : `<p>${inline(line)}</p>`);
  }
  if (list) out.push(`<ul>${list.join("")}</ul>`);
  return out.join("");
}
